import React from 'react';
import env from 'env';
import { useRouter } from 'components';
import { getProductEditModel } from './productEditFormModel';
import { usePost } from 'components';
import { useForm } from 'form';
import { Button, ErrorMessage } from 'components';
import { SiteLink } from 'components';

export function ProductNew(props) {
  const model = getProductEditModel({});
  console.log(model)

  return <ProductEditForm model={model} />
}

function ProductEditForm({ model }) {
  const form = useForm(model, {});
  const post = usePost();
  const { Redirect } = useRouter();

  const render = (name) => form.renderControl(name);

  function save(e) {
    form.validateForm(e, () => {
      const value = { ...form.getValue() };
      post.send(env.apiBase + "/api/productAdmin/createProduct", value);
    })
  }

  if (post.done()) {
    const productId = post.response.results.productId;
    return <Redirect to={`/admin/product/${productId}`} />
  }

  return (
    <div className="editor productEditor">
      <h1>New Product</h1>

      <section>
        <div className="row">
          <div className="col-md-9">{render('productName')}</div>
        </div>
        <div className="row">
          <div className="col-12 actions">
            <ErrorMessage errors={form.errors} />
            <ErrorMessage errors={post.errors} />
            <Button onClick={save} status={form.status}>Create</Button>
            <SiteLink className="btn btn-outline-dark" to="/admin/products">Cancel</SiteLink>
          </div>
        </div>
      </section>
    </div>
  );
}